export const CATEGORY_HIERARCHY = {
  sneakers: {
    basketball: 'Basketball',
    boots: 'Boots',
    cleats: 'Cleats',
    lifestyle: 'Lifestyle',
    running: 'Running',
    sandals: 'Sandals',
    skateboarding: 'Skateboarding',
  },
  apparel: {
    bottoms: 'Bottoms',
    dresses: 'Dresses',
    outerwear: 'Outerwear',
    swimwear: 'Swimwear',
    tops: 'Tops',
  },
};

export const ROBUST_TITLE_TEXT_FOR_SUBCATEGORIES: {
  bottoms: string;
  outerwear: string;
  tops: string;
} = {
  bottoms: 'jeans, pants, shorts, and more',
  outerwear: 'blazers, jackets, coats, and more',
  tops: 't-shirts, hoodies, sweatshirts, and more',
};

export const PDP_SUBCATEGORIES = new Set([
  'basketball',
  'boots',
  'cleats',
  'lifestyle',
  'running',
  'sandals',
  'skateboarding',
  'bottoms',
  'dresses',
  'outerwear',
  'swimwear',
  'tops',
]);
